import { useContext } from 'react';

import type { ProPageContextProps } from 'src/modules/pro/providers/ProPageProvider';
import { proPageContext } from 'src/modules/pro/providers/ProPageProvider';

export const useProPageContext = (): ProPageContextProps => {
  const context = useContext(proPageContext);
  return context;
};
